@if (isVisible()) {
  <div class="container-wrap">
    <rt-impact-tracker-insights
      [logoHeading]="'tlc.impact_tracker.metrics_banner.metrics_dropdown.logo_heading' | translate"
      [subheading]="'tlc.impact_tracker.metrics_banner.metrics_dropdown.subheading' | translate"
    >
      @if (impactTrackerService.canShowDialogTrigger()) {
        <ng-container cta>
          <div (click)="openDialog()" class="cta-wrap">
            <span>{{ 'tlc.impact_tracker.metrics_banner.metrics_dropdown.cta' | translate }}</span>
            <rt-icon name="arrow-forward" margin-left-small-xx></rt-icon>
          </div>
        </ng-container>
      }
      <ng-container insights>
        @for (card of cards(); track $index) {
          <rt-insights-card
            [iconName]="$any(card.icon)"
            [value]="$any(card.value)"
            [title]="card.title"
            [label]="card.label"
          />
        }
      </ng-container>
    </rt-impact-tracker-insights>
  </div>
}
